<template>
  <div class="select">
    <input readonly type="text" :value="timeFromat" :placeholder="placeholder" class="input" @click="visible = true" />
    <Popup v-model="visible" position="bottom">
      <div class="van-hairline--top-bottom van-picker__toolbar">
        <button class="van-picker__cancel" @click="visible = false">
          {{ $t('common.cancel') }}
        </button>
        <button class="van-picker__confirm" @click="onConfirm">
          {{ $t('common.confirm') }}
        </button>
      </div>
      <div class="cover">
        <div class="left">
          <span class="title">{{ $t('visitor.apply.time.start') }}</span>
          <DatetimePicker
            v-model="start"
            type="time"
            :show-toolbar="false"
            :filter="filters"
            :max-hour="startMaxHour"
            :max-minute="startMaxMinute"
          />
        </div>
        <div class="divider"></div>
        <div class="right">
          <span class="title">{{ $t('visitor.apply.time.end') }}</span>
          <DatetimePicker
            v-model="end"
            type="time"
            :show-toolbar="false"
            :filter="filters"
            :min-hour="endMinHour"
            :min-minute="endMinMinute"
          />
        </div>
      </div>
    </Popup>
  </div>
</template>

<script>
import moment from 'moment';
import { DatetimePicker, Popup } from 'vant';
export default {
  props: ['value', 'placeholder', 'filter'],
  components: { DatetimePicker, Popup },
  data() {
    return {
      visible: false,
      minDate: new Date(moment().format('YYYY-MM-DD')),
      start: this.value[0],
      end: this.value[1],
    };
  },
  computed: {
    timeFromat() {
      return this.start + '~' + this.end;
    },
    startMaxHour() {
      return this.end.split(':')[0];
    },
    startMaxMinute() {
      return this.startMaxHour === this.endMinHour ? this.end.split(':')[1] : 59;
    },
    endMinHour() {
      return this.start.split(':')[0];
    },
    endMinMinute() {
      return this.startMaxHour === this.endMinHour ? this.start.split(':')[1] : 0;
    },
  },
  methods: {
    onConfirm() {
      const value = [this.start, this.end];
      this.$emit('update:value', value);
      this.visible = false;
    },
    filters(type, options) {
      if (this.filter) {
        return this.filter(type, options);
      }
      return options;
    },
  },
};
</script>

<style lang="less" scoped>
.select {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;

  .input {
    border: none;
    font-size: 30px;
    padding: 6px 0;
    line-height: 34px;
    color: #3d424d;
    width: 100%;

    &::placeholder {
      color: #949aa4;
    }
  }

  .cover {
    display: flex;
    justify-content: center;
    align-items: center;

    .left,
    .right {
      width: 350px;

      .title {
        font-size: 28px;
        color: #3d424d;
      }
    }
    .divider {
      margin-top: 80px;
      width: 1px;
      height: 320px;
      background-color: #f0f2f5;
    }
  }
}
</style>
